import React from "react";
import MainSection from "../components/MainSection";
import ServicesContentContainer from "../components/ServicesContentContainer";

const Ec = () => {
  const contentData = [
    {
      id: 1,
      title: "Understanding Your Goals",
      description:
        "Our counseling process begins with a comprehensive discussion where we work to understand your educational and career aspirations, your skills, interests, and strengths. This conversation, which can take place either in-person at our office or virtually to suit your convenience, helps us to tailor our advice and recommendations to your unique needs and goals.",
    },
    {
      id: 2,
      title: "Developing Your Academic Profile",
      description:
        "Once we understand your objectives, we help you build a detailed academic profile that highlights your past achievements, current skills, and future potential. This profile will serve as a foundation for exploring educational and career pathways that align with your goals.",
    },
    {
      id: 3,
      title: "Exploration and Information",
      description:
        "Armed with your profile, we assist in identifying suitable academic opportunities and career prospects. We provide detailed insights into prospective courses, universities, and industries that match your ambitions. Our counselors supply you with the most recent information regarding course requirements, curriculum structures, potential challenges, and specifics about your chosen academic field.",
    },
    {
      id: 4,
      title: "Decision Making and Planning",
      description:
        "With the information at hand, we assist you in making informed decisions about your future. We work collaboratively to devise a personalized strategy that covers academic readiness, financial planning, and effective time management. We also frequently host webinars and conferences featuring industry experts, providing you with the opportunity to gain a wider perspective and valuable insights.",
    },
    {
      id: 5,
      title: "Preparatory Sessions and University Interaction",
      description:
        "To further help you make an informed choice, we conduct preparatory sessions which include interaction with university representatives. You'll have the opportunity to ask questions and gather firsthand knowledge about your chosen institutions.",
    },
    {
      id: 6,
      title: "Counseling on Course Selection",
      description:
        "Our counselors help you navigate the often overwhelming task of course selection. We provide details about the curriculum, faculty, facilities, student reviews, and other course-specific information to aid you in this process. Our goal is to ensure you make a decision that resonates with your career aspirations.",
    },
    {
      id: 7,
      title: "Assistance with Financial Planning",
      description:
        "We understand that financing your education is a significant consideration. Thus, our counseling also includes guidance on scholarships, financial aid options, cost of living in different countries, and ways to manage your finances while studying abroad.",
    },
  ];
  const conclusion =
    "Throughout your journey, we are here to offer support, advice, and the expertise you need to make your educational aspirations a reality.";

  return (
    <>
      <MainSection bannerTxt="EDUCATION COUNSELING" color="gray" />
      <ServicesContentContainer
        contentData={contentData}
        title={"Education Counseling"}
        includeTxt={"Processes"}
        conclusion={conclusion}
      />
    </>
  );
};

export default Ec;
